module.exports = __webpack_public_path__ + "static/media/8.a6a4efde.png";